module.exports = __webpack_public_path__ + "img/Cloud_0.3faf536c.png";